import React from "react";
import CardHeader from "./CardHeader/cardHeader";
import CardSearch from "./CardSearch/cardSearch";
import CardUsers from "./CardUsers/cardUsers";

function UsersScreen(props) {
    return (
        <>
            <CardHeader />
            <CardSearch />
            <CardUsers />
        </>
    )
}

export default UsersScreen
